<template>
  <div class="container" @click="showdown = false">
    <div class="view-qrcode" @click.stop="showdown = !showdown">
      <i class="fjyk-qr-code iconfont qrcode" style="font-size: 80px"></i>
    </div>
    <div class="login_block">
      <div class="leftImg">
        <img src="../../assets/img/cardLeftImg.png" />
      </div>
      <div class="rightForm">
        <div id="titleText">
          <div id="dividerAndText">
            <div id="dividerContainer">
              <div id="lineLeft"></div>
            </div>
            <div id="titleFont">
              <span>欢迎登录</span>
            </div>
            <div id="dividerContainer">
              <div id="lineRight"></div>
            </div>
          </div>
        </div>
        <div id="formContainer">
          <el-form
            ref="el_form"
            label-position="top"
            :model="form"
            :rules="rules"
            @keyup.enter.native="handle_login"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item prop="username" label="用户名">
                  <!-- autofocus 进入页面后聚焦，可直接按回车登录 -->
                  <el-input
                    autofocus
                    v-model="form.username"
                    placeholder="请输入用户名"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item prop="password" label="密码">
                  <el-input
                    v-model="form.password"
                    type="password"
                    placeholder="请输入密码"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-checkbox v-model="isRemember"
                  >记住用户名和密码</el-checkbox
                ></el-col
              >
            </el-row>
          </el-form>
          <div class="buttonContainer">
            <el-button
              :loading="login_state"
              round
              type="primary"
              @click="handle_login"
              >登录</el-button
            >
          </div>
          <div class="copyrightContainer">
            Copyright © 2021 福建远控科技有限公司
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="down-class" v-show="showdown" @click.stop="showdown = true">
        <div class="qr-class">
          <div>
            <div class="qr-text">Android</div>
            <div class="qr-url">
              <vue-qr :text="qrcodeurl" :size="200"></vue-qr>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
let Base64 = require('js-base64').Base64
import vueQr from 'vue-qr'

export default {
  components: {
    vueQr,
  },
  data() {
    return {
      qrcodeurl: 'https://oa.fzgdyk.com/app/app-release.apk',
      showdown: false,
      form: {
        username: '',
        password: '',
      },
      // 是否记住用户名和密码
      isRemember: false,
      rules: {
        username: [
          // { required: true, message: '请输入用户名', trigger: 'change' }
          { validator: this.validUsername, trigger: 'change' },
        ],
        password: [
          // { required: true, message: '请输入密码', trigger: 'change' },
          {
            min: 1,
            max: 16,
            message: '长度在 1 到 16 个字符',
            trigger: 'blur',
          },
          { validator: this.validPassword, trigger: 'change' },
        ],
      },
      login_state: false,
    }
  },
  created() {
    this.getStorage()
  },
  methods: {
    // 登录
    async handle_login() {
      if (this.$route.path !== '/Login') {
        return
      }
      this.$refs['el_form'].validate(async (valid) => {
        if (!valid) {
          return
        }
        const username = this.form.username
        // 会被转为md5的密码
        let password = this.form.password
        // md5转换前的密码
        let noMD5pwd = password

        password = this.$md5.md5(password)
        // 暂时使用
        const { data: res } = await this.$http.post('/login', {
          userName: username,
          password: password,
        })
        if (res.isSuccess) {
          this.$store.commit('set_accessToken', res.data.accessToken)
          this.$store.commit('set_refreshToken', res.data.refreshToken)
          let expiredTime = new Date().getTime() + res.data.expire * 60 * 1000
          this.$store.commit('set_expirationTime', expiredTime)
          this.$store.commit('set_effectiveMinutes', res.data.expire)
          res.data.authorityList.forEach((i) => {
            i['key'] = i.name
            i.children.forEach((j) => {
              j['key'] = i.name + '-' + j.name
              j.children.forEach((k) => {
                k['md5Path'] = this.$md5.md5(k.path + k.menuArgs)
                k['key'] = i.name + '-' + j.name + '-' + k.name + '-' + k.id
              })
            })
          })
          this.$store.commit('set_menulist', res.data.authorityList)
          this.$store.commit('set_userInfo', {
            userNum: res.data.userNum,
            userName: res.data.userName,
            userId: res.data.userId,
            deptName: res.data.deptName,
            deptId: res.data.deptId,
            banZu: res.data.banZu,
            gangWeiId: res.data.gangWeiId,
            gangWei: res.data.gangWei,
            company: res.data.company,
          })
          if (res.data.systemSettingJson) {
            const obj = JSON.parse(res.data.systemSettingJson)
            this.$store.commit('set_systemSettingByObj', obj)
          } else {
            const obj = {
              theme: 'default',
              defaultSearch: 'all',
              explainSort: 'desc',
              ifShowQuestionDetail: 'no',
            }
            this.$store.commit('set_systemSettingByObj', obj)
          }
          sessionStorage.setItem('state', JSON.stringify(this.$store.state))
          this.setStorage(username, noMD5pwd)
          this.$message.success('登陆成功')
          this.$router.push('/Home')

          // 获取当前未完成的待办事项数
          this.$bus.$emit('getTodoNumber')
          this.$bus.$emit('getQuestionNumber')
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },

    // 设置缓存 [是否记住用户名和密码 | 用户名 | 密码]
    setStorage(username, password) {
      localStorage.setItem('userName', username)
      localStorage.setItem('password', Base64.encode(password))
      // 将是否记住密码存为缓存
      localStorage.setItem('isRemember', this.isRemember)
    },
    // 获取缓存值
    getStorage() {
      const isStorageRemember = localStorage.getItem('isRemember')
      if (isStorageRemember === 'true') {
        this.isRemember = true
      } else {
        this.isRemember = false
      }
      // 如果用户勾选了要记住用户名密码，且存在缓存则直接赋值
      if (
        this.isRemember &&
        localStorage.getItem('userName') &&
        localStorage.getItem('password')
      ) {
        this.form.username = localStorage.getItem('userName')
        this.form.password = Base64.decode(localStorage.getItem('password'))
      }
    },
    // // 登录
    // handle_login() {
    //   const that = this
    //   this.$refs['el_form'].validate(async (valid) => {
    //     if (valid) {
    //       const form = { ...this.form }
    //       form.password = this.$md5.md5(form.password)
    //       const { data: res } = await that.$http.post('/login', form)
    //       if (!res.isSuccess) {
    //         this.$message.error(res.errorMessage)
    //         return
    //       }
    //       const nowTime = new Date().getTime()
    //       this.$store.commit('set_accessToken', res.data.access_token)
    //       this.$store.commit('set_expirationTime', nowTime + res.data.expirationTime)
    //       this.$message.success('登录成功！')
    //       // this.$store.commit('set_activeMenu', '/HomePage')
    //       // that.$store.commit('set_openAcitveMenu', '通用模块')
    //       this.$nextTick(() => {
    //         that.$router.push('/Home')
    //       })
    //     } else {
    //       this.$message.error('登陆失败，请检查账号密码')
    //       return false;
    //     }
    //   });
    // },
    validUsername(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    },
    validPassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    },
    // 获取验证码
    // async getCode() {
    //   const { data: res } = await this.$http.get('/captchaImage')
    //   if (res.code !== 200) {
    //     this.$message.error(res.msg)
    //     return
    //   }
    //   return res.data.captchaOnOff
    // }
  },
  computed: {},
}
</script>

<style lang="less" scoped>
.flexXY(@x: center, @y: center) {
  display: flex;
  justify-content: @x;
  align-items: @y;
}
.container {
  // background: rgb(58, 134, 248);
  // background: #373d41;
  background-image: url(../../assets/img/loginBackground2.png);
  background-size: 100%;
  // background-image: url(../../assets/img/loginBackground.jpg);
  width: 100%;
  height: 100%;
  .flexXY;
}
.login_block {
  background: #fff;
  width: 1000px;
  height: 581px;
  // padding: 10px;
  border-radius: 10px;
  box-shadow: 2px 2px 2px rgb(196, 193, 193);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  .leftImg {
    width: 568px;
    height: 100%;
    border-radius: 10px 0 0 10px;
    overflow: hidden;
    img {
      height: 100%;
    }
  }
  .rightForm {
    width: calc(100% - 568px);
    height: 100%;
    #titleText {
      width: 100%;
      height: 30%;
      display: flex;
      align-items: center;
      #dividerAndText {
        width: 100%;
        height: 60px;
        padding: 0 40px;
        display: flex;
        #dividerContainer {
          width: 33%;
          height: 100%;
          div {
            width: 100%;
            height: 2px;
            background: #000;
            margin: 29px 0;
          }
          #lineLeft {
            background-image: linear-gradient(
              to right,
              #f8f8f8,
              rgb(104, 102, 102)
            );
          }
          #lineRight {
            background-image: linear-gradient(
              to right,
              rgb(104, 102, 102),
              #f8f8f8
            );
          }
        }
        #titleFont {
          width: 34%;
          height: 100%;
          .flexXY;
          span {
            font-size: 28px;
            font-weight: 500;
            margin-bottom: 4px;
          }
        }
      }
    }
    #formContainer {
      padding: 0 50px;
      /deep/ .el-form-item__label {
        padding: 0 !important;
        font-size: 17px !important;
        font-weight: 500;
        color: #000;
      }
      /deep/ .el-input__inner {
        border: 0 !important;
        border-bottom: 1px solid #d1d1d1 !important;
        border-radius: 0;
        padding-left: 0 !important;
        transition: all 0.3s;
      }
      // /deep/ .el-input__inner:hover {
      //   padding-left: 10px !important;
      //   transition: all 0.3s;
      // }
      /deep/ .el-input__inner:focus {
        padding-left: 10px !important;
        transition: all 0.3s;
      }
      .buttonContainer {
        width: 100%;
        height: 100px;
        margin-bottom: 20px;
        .flexXY;
        .el-button {
          width: 80%;
          height: 50px;
          border-radius: 50px;
          font-size: 20px;
        }
      }
      .copyrightContainer {
        width: 100%;
        text-align: center;
        font-size: 14px;
      }
    }
  }
}
.el-card {
  border-radius: 20px !important;
}
.box_card {
  width: 70%;
  height: 60%;
  .box_header {
    width: 100%;
    height: 40px;
    margin-bottom: 15px;
    line-height: 40px;
    color: #333;
    text-align: center;
    font-size: 24px;
  }
  .box_form {
    width: 100%;
    margin-bottom: 20px;
  }
}
.el-form {
  margin-bottom: 5px !important;
}
#font_icon {
  font-size: 20px;
}
.el-form {
  margin-bottom: 20px;
}
.view-qrcode {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  color: rgb(98, 91, 91);
  width: 80px;
  height: 80px;
}
.qrcode {
  z-index: 3;
  position: absolute;
  right: 0;
  top: 0;
  margin-top: -20px;
}
.qrcode:hover {
  cursor: pointer;
  color: #333333;
}
.down-class {
  position: absolute;
  right: 0;
  height: 100%;
  width: 250px;
  float: right;
  z-index: 1;
  transition: 0.3s all;
  background: rgba(0, 0, 0, 0.1);
  .qr-class {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .qr-text {
      width: 250px;
      display: flex;
      font-size: 20px;
      margin-bottom: 10px;
      justify-content: center;
      align-items: center;
    }
    .qr-url {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-leave-to {
  opacity: 0;
}
.fade-leave-active {
  transition: opacity 1s;
}
</style>
